import { CLEAR_NOTIF, ADD_NOTIF, DELETE_NOTIF } from './NotifType';

export default function NotifReducer(state, action) {
    let newState = null;

    switch(action.type) {
        case CLEAR_NOTIF:
            newState = {
                ...state,
                notifs: []
            }
        return newState;

        case ADD_NOTIF:
            let found = state.notifs.find(notif => notif.bookingFolderId === action.payload.bookingFolderId);
            if(found === undefined) {
                newState = {
                    ...state,
                    notifs: [...state.notifs, action.payload]
                }
                return newState
            } else {
                return state;
            }
            
        case DELETE_NOTIF:
            let deletedState = state.notifs.filter(notif => notif.bookingFolderId !== action.payload);
            newState = {
                ...state,
                notifs: [...deletedState]
            }

            return newState
        default: 
            return state
    }
}